import React, { useState } from 'react';
import CandleChart from '../components/CandleChart';

export default function Charts() {
  const [symbol, setSymbol] = useState('BTC');
  const [tf, setTf] = useState('1h');
  const [customSymbol, setCustomSymbol] = useState('');

  const defaultSymbols = ['BTC', 'ETH', 'BNB', 'SOL', 'XRP', 'DOGE'];
  const timeframes = ['1m', '5m', '15m', '1h', '4h', '1d'];

  const handleCustomSubmit = (e) => {
    e.preventDefault();
    if (customSymbol.trim()) {
      setSymbol(customSymbol.trim().toUpperCase());
      setCustomSymbol('');
    }
  };

  return (
    <div className="p-4 md:p-6 bg-[#0d1117] min-h-screen text-white">
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold">Live Charts</h1>
        
        <div className="flex gap-2 flex-wrap justify-center">
          {timeframes.map((t) => (
            <button
              key={t}
              onClick={() => setTf(t)}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${tf === t ? 'bg-orange-500 text-white' : 'bg-[#161b22] text-gray-400 hover:bg-gray-700'}`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <form onSubmit={handleCustomSubmit} className="flex flex-col sm:flex-row gap-2 mb-6">
        <input 
          type="text" 
          placeholder="Enter custom coin (e.g. PEPE, SOL)" 
          value={customSymbol}
          onChange={(e) => setCustomSymbol(e.target.value)}
          className="w-full bg-[#161b22] border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-orange-500"
        />
        <button type="submit" className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 px-8 py-3 rounded-lg font-bold transition-colors whitespace-nowrap">
          Load Chart
        </button>
      </form>

      <div className="flex gap-2 overflow-x-auto pb-4 mb-4 scrollbar-hide">
        {defaultSymbols.map((s) => (
          <button
            key={s}
            onClick={() => setSymbol(s)}
            className={`px-5 py-2 rounded-full whitespace-nowrap text-sm font-bold transition-colors ${symbol === s ? 'bg-white text-black' : 'bg-[#161b22] text-gray-300 hover:bg-gray-700 border border-gray-800'}`}
          >
            {s}/USDT
          </button>
        ))}
      </div>

      <div className="bg-[#161b22] rounded-2xl border border-gray-800 overflow-hidden shadow-2xl">
        <div className="p-4 border-b border-gray-800 flex justify-between items-center">
          <h2 className="text-lg font-bold">{symbol} / USDT</h2>
          <span className="text-sm text-green-400 bg-green-400/10 px-3 py-1 rounded-full">Binance</span>
        </div>
        <div className="h-[500px] md:h-[600px] w-full">
          <CandleChart key={symbol + tf} symbol={symbol} tf={tf} />
        </div>
      </div>
    </div>
  );
}
